define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi/_base/underscore",
	"csi/action/NewRefNodeMixin",
	"csi/table"
], function(declare, domClass, _,NewRefNodeMixin, csiTable) {

	return declare(NewRefNodeMixin, {
		/** @property {number} nNew -  number of new nodes created */
		nNew: 0,

		/** @property {boolean} bNewRowStyling - add green background to newly added rows */
		bNewRowStyling: true,

		// DOMNode: parent row of new row(s)
		//newParent: null,

		/**
		 * @param {boolean} bInsert - true if insert action is active
		 */
		_newPostProcess: function(bInsert) {
			// summary: if row action, then refresh row; otherwise, generate rows for new nodes
			if (this.bEditHeading == null) {
				this.bEditHeading = !this.m_proxy && !this.usedReactDialog;
			}

			var nodes = this.getNewNodes();

			// strip out nulls
			// to support the case where the PostAction needs to refresh whole table
			// and nodes are not returned to the client for caching.
			nodes = _.filter(nodes, Boolean);

			if (this.nNew = nodes.length) {
				var dfd;
				var w = this.widget;
				if (w.hasGroups() && w.hasGroupRows()) {
					var bNewActionsBtn = w.isNewActionsButton(this.refNode);
					if (bNewActionsBtn || this.bAddToNewGroup) {
						this.newParent = w.generateNewlyCreatedRow(nodes);

						dfd = this.when(w.expandRow(this.newParent), () => {
							// Refresh newParent after group expanding - it's possible it was refreshed after expanding (groups refresh to make sure count is right)
							this.newParent = w.generateNewlyCreatedRow(nodes);
							w.setHierarchyState(this.newParent, csiTable.HS_MINUS);
						});
					}
				}

				this.when(dfd, () => {
					// Load all table results if adding to ordered table
					var qr = w.getQueryResult();
					var bOrderedTable = w.hasResultRows() && qr.hasOrderedChildren();
					if (bOrderedTable) {
						var bMore = w.moreAction && qr.hasMoreChildren();
						if (bMore) {
							dfd = w.queryMoreForMainLevel();
						}
					}

					// Add new rows
					this.when(dfd, () => {
						// Check if nodes were already added to the table as a result of group expand operation
						var nodesAlreadyAdded = w.getQueryResult(nodes[0].$URL);
						var rows = []; // added rows

						if (nodesAlreadyAdded) {
							// highlight and scroll to already added nodes
							_.each(nodes, function(node) {
								rows.push(w.getRefNodeByUrl(node.$URL));
							});

							this._newRows(rows);
						} else {
							// add new rows to the table - must determine where to insert before generating the rows, as doing so
							// generates query results and would affect the insert location
							const refNodeNext = this._newFindInsertLocation(bInsert);
							const qr = w.getQueryResultByDomNode(this.newParent);
							const emptyTable = !w.hasResultRows();
							const rows = w.generateRow(nodes, qr);

							if (emptyTable) {
								// if adding first row (was seeing placeholder), then add action row as well
								const actionRow = w.generateActionRow(qr);
								if (actionRow) {
									rows.push(actionRow);
								}
							}

							this._newRows(rows, true, refNodeNext);
						}

						// Scroll to the last inserted row
						var len = rows.length;
						w.scrollIntoView(len && rows[len - 1]);
					});
				});
			}
		},

		/**
		 * Insert new row(s) from table actions, highlight inserted rows with green, add transition affects
		 * @param {DOMNode[]} aRows - list of rows to add ([tr])
		 * @param {boolean} [bInsertRows] - true if rows need to be added to DOM
		 * @param {DOMNode} [refNodeNext] - DOMNode to insert new rows before; if not specified, then add to end
		 */
		_newRows: function(aRows, bInsertRows, refNodeNext) {
			var view = this.widget;
			var oldSelection = null;
			var bSelectionSimulation = view._selectionSimulation();
			var bRequireSelection = (this.nNew == 1) || (view.defView.m_formData && !view.defView.m_formData.getSelectedNode());

			if (bRequireSelection && bSelectionSimulation) {
				var selectedRows = view.getSelectedRows();
				if (selectedRows.length) {
					oldSelection = selectedRows[0];
					domClass.add(oldSelection, "csi-no-transition");
					view.unselectAll();
				}
			}

			// Change inserted rows background color to green
			if (this.bNewRowStyling) {
				_.each(aRows, function(row) {
					if (!view.isActionRow(row)) {
						domClass.add(row, "csi-background-new-row");
					}
				});
			}

			// Wait for 4 seconds, then revert inserted rows background color back to ""
			setTimeout(function() {
				_.each(aRows, function(row) {
					domClass.remove(row, "csi-no-transition");
					domClass.remove(row, "csi-background-new-row");
				});
				if (oldSelection) {
					domClass.remove(oldSelection, "csi-no-transition");
				}
			}, 4000);

			if (bInsertRows) {
				// Update table structures with new row(s)
				const rowParent = view.insertRows(aRows, this.newParent, refNodeNext, true);

				// if parent changed (or was refreshed), then reset
				if (rowParent) {
					this.newParent = rowParent;
				}
			}

			if (bRequireSelection) {
				var row = aRows[0];
				this._newPostProcessRefNode(row);

				// Select
				if (bSelectionSimulation) {
					view._selectRow(row, true, true);
				}
			}
		},

		/**
		 * Find appropriate location for new nodes based on where action coming from and the type of table (grouped, ordered, etc.)
		 * @param {boolean} bInsert
		 * @return {DOMNode} - return row to insert new rows before
		 */
		_newFindInsertLocation: function(bInsert) {
			// Row adding rules:
			// Ordered table is the table that is ordered or can be ordered (ordered table with enabled column sort)
			// Ordered tables without group from toolbar button - add to the end of the table
			// Ordered tables with group:
			//   - from toolbar button, add to the end of the Newly Created group or to the end of Section (if groupped by section (BOM Placements and Spec)
			//   - from action row button, add to the end of this group
			// Unordered Tables without group from toolbar button - add to the top of the table
			// Unordered Tables with group from toolbar button - add to "Newly Created" group at the table top
			// Unordered Tables with group from group row action - add to the top of the group (Currently group row New actions are not avaialbe)
			// Operation "Insert row" - inserts before specified row (before rowNext)

			const view = this.widget;
			const body = view.bodyNode;
			const lastChild = body.lastChild;
			const qrRoot = view.getQueryResult();
			const bGroups = qrRoot.containsGroups();
			const bOrderedNoGroups = !bGroups && qrRoot.hasOrderedChildren();
			let rowNext = this.refNodeNext;

			// by default refNodeNext is same as refNode, which could be the actions button
			const bNewActionsBtn = view.isNewActionsButton(rowNext);

			if (!bInsert && bOrderedNoGroups) {
				var elem = bNewActionsBtn ? lastChild : (rowNext || lastChild);
				rowNext = (elem && view.isActionRow(elem)) ? elem : null;
			} else if (bNewActionsBtn || this.bAddToNewGroup) {
				if (bGroups) {
					// if no children, then insert before next sibling (if any); otherwise, insert before first or last child (factoring in report and action rows)
					const rowParent = this.newParent;
					const qrParent = view.getQueryResultByDomNode(rowParent);
					const qrNext = qrParent.getChildResultWhereToInsert();
					rowNext = qrNext ? view.getRefNodeById(qrNext.id) : view.getRefNodeNext(rowParent);
				} else {
					// get first result in table other than root row
					const rootRow = view.getRootRow();

					rowNext = rootRow ? rootRow.nextSibling : body.firstChild;

					if (view.isReportRow(rowNext)) {
						rowNext = rowNext.nextSibling;
					}
				}
			}

			// if last row is action row - insert before action row
			if (!rowNext && lastChild && view.isActionRow(lastChild)) {
				rowNext = lastChild;
			}

			return rowNext;
		},
	});
});